/* istanbul ignore file */
import { ShowDate } from 'framework/ui/ui-builder';
import { PrepopulationForm } from 'domain/people/employee/prepopulation/PrepopulationContext';
import { DATE_FORMAT } from 'framework/utils';
import { Typography } from '@mui/material';

type PrepopulateFormDataLayoutProps = {
  form: PrepopulationForm;
};

const PrepopulateFormDataLayout = ({ form }: PrepopulateFormDataLayoutProps) => {
  const { id, name, updatedAt } = form;

  return (
    <>
      <Typography component="div">
        <Typography component="span" variant="subtitle1">
          Form name:
        </Typography>{' '}
        {name}
      </Typography>
      <Typography component="div">
        <Typography component="span" variant="subtitle1">
          Form submission:
        </Typography>{' '}
        ID {id} updated at <ShowDate dateUTC={updatedAt} format={DATE_FORMAT.SIMPLE} />
      </Typography>
    </>
  );
};

export default PrepopulateFormDataLayout;
